// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tagColor__BI3AH6n2iA{width:8px;height:8px;border-radius:50%}`, "",{"version":3,"sources":["webpack://./src/components/tagSelect/tagSelect.module.scss"],"names":[],"mappings":"AAAA,sBACE,SAAA,CACA,UAAA,CACA,iBAAA","sourcesContent":[".tagColor {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tagColor": `tagColor__BI3AH6n2iA`
};
export default ___CSS_LOADER_EXPORT___;
